export const orderConstants = {
  GET_ORDER: "GET_ORDER",
  SET_ORDER: "SET_ORDER",
  SET_ORDER_LOADING: "SET_ORDER_LOADING",
};
